import keyMirror from 'keymirror';

export const ScaleActionTypes = keyMirror({
  START_SCALE: undefined,
  SET_END_POS: undefined,
  TURN_OFF_SCALE: undefined,
  SET_START_POS: undefined,
});

